import React from 'react';

import { Box, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'next-i18next';

import { useBreakpointV2 } from '@helpers/use';
import { numberWithCommas } from '@helpers/utils';

type PriceBoxProps = {
  isDiscount?: boolean;
  salePrice?: number;
  fullPrice?: number;
};

const PriceBox = ({ isDiscount, salePrice = 0, fullPrice = 0 }: PriceBoxProps) => {
  const theme = useTheme();
  const { t } = useTranslation('store_course');
  const { isMobile } = useBreakpointV2();
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: '14px', md: '24px' } }}>
      <Typography variant={isMobile ? 'h3' : 'h1'}>
        {t('course_detail.header_banner.purchase.price.text', { price: numberWithCommas(salePrice) })}
      </Typography>
      {isDiscount && (
        <Typography
          sx={{
            display: 'flex',
            alignItems: 'center',
            textDecoration: 'line-through',
            color: theme.palette.textOnPrimary.secondary,
            fontWeight: {
              md: 400,
              xs: 500,
            },
            lineHeight: {
              md: '36px',
              xs: '22px',
            },
          }}
          variant={isMobile ? 'body2' : 'h4'}
        >
          {t('course_detail.header_banner.purchase.price.text', { price: numberWithCommas(fullPrice) })}
        </Typography>
      )}
    </Box>
  );
};

export default PriceBox;
